import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import starIcon from "../../static/images/star-icon.png";
import contact from "../../static/images/contact.png";

const ContactForm = () => {
  const formRef = useRef(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const botField = formRef.current?.elements?.bot_field?.value;

    if (botField) {
      setStatus("Spam detected. Message not sent.");
      setStatusType("error");
      return;
    }

    setIsSending(true);
    setStatus("");
    setStatusType("");

    emailjs
      .sendForm(
        "service_vi0josa",
        "template_enh9l75",
        formRef.current,
        "Foxhp8JCuiPp-WgGq"
      )
      .then(
        () => {
          setStatus(
            "Thank you. Your enquiry has been submitted successfully. A member of the CloudLogic IT Solutions team will review your request and get back to you shortly."
          );
          setStatusType("success");
          formRef.current.reset();
          setPhoneNumber("");
          setIsSending(false);
        },
        () => {
          setStatus("Sorry, your message could not be sent. Please try again.");
          setStatusType("error");
          setIsSending(false);
        }
      );
  };

  return (
    <section className="contact-form-section pb-100">
      <div className="container">
        <div className="contact-form-header">
          <span className="contact-form-subtitle">
            <img src={starIcon} alt="" />
            Book a Microsoft 365 Health Check
          </span>

          <h2>Plan Your Next Microsoft Cloud Improvement</h2>

          <p>
            Use this form to request a Microsoft 365 Health Check, discuss a
            migration, SharePoint or Teams project, security or governance
            concern, automation opportunity, compliance readiness need, or
            managed Microsoft cloud support.
          </p>
        </div>

        <div className="row align-items-center g-4">
          <div className="col-lg-5 col-md-12">
            <div className="contact-form-image-wrap">
              <img
                src={contact}
                alt="Contact CloudLogic IT Solutions for Microsoft cloud security and IT support"
                className="contact-form-image"
              />
            </div>
          </div>

          <div className="col-lg-7 col-md-12">
            <div className="contact-form-card">
              <form
                ref={formRef}
                onSubmit={handleSubmit}
                className="contact-form-custom"
              >
                <div className="contact-form-honeypot" aria-hidden="true">
                  <label htmlFor="bot_field">Do not fill this out</label>
                  <input
                    type="text"
                    id="bot_field"
                    name="bot_field"
                    tabIndex="-1"
                    autoComplete="off"
                  />
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="contact-form-group">
                      <label htmlFor="name">Full Name</label>
                      <input
                        id="name"
                        type="text"
                        name="name"
                        className="contact-input"
                        required
                        placeholder="Your full name"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-form-group">
                      <label htmlFor="email">Email Address</label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        className="contact-input"
                        required
                        placeholder="you@example.com"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-form-group">
                      <label htmlFor="phone_number">Phone Number</label>
                      <input
                        id="phone_number"
                        type="tel"
                        name="phone_number"
                        className="contact-input"
                        required
                        value={phoneNumber}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(
                            /[^0-9+\-\s()]/g,
                            ""
                          );
                          setPhoneNumber(cleanedValue);
                        }}
                        placeholder="Your best contact number"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-form-group">
                      <label htmlFor="subject">Service Required</label>
                      <select
                        id="subject"
                        name="subject"
                        className="contact-input"
                        required
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a service *
                        </option>
                        <option value="Microsoft 365 Health Check">
                          Microsoft 365 Health Check
                        </option>
                        <option value="SharePoint, Teams & Digital Workplace">
                          SharePoint, Teams & Digital Workplace
                        </option>
                        <option value="Power Platform & Workflow Automation">
                          Power Platform & Workflow Automation
                        </option>
                        <option value="Microsoft 365 Setup, Governance & Migration">
                          Microsoft 365 Setup, Governance & Migration
                        </option>
                        <option value="Azure Cloud Modernisation & Managed Support">
                          Azure Cloud Modernisation & Managed Support
                        </option>
                        <option value="Security, Governance & Compliance Alignment">
                          Security, Governance & Compliance Alignment
                        </option>
                        <option value="Identity Protection & Access Governance">
                          Identity Protection & Access Governance
                        </option>
                        <option value="Managed IT Support & Operational Assistance">
                          Managed IT Support & Operational Assistance
                        </option>
                        <option value="CloudLogic Career AI & Workforce Programs">
                          CloudLogic Career AI & Workforce Programs
                        </option>
                        <option value="Service Catalogue & Pricing">
                          Service Catalogue & Pricing
                        </option>
                        <option value="Community, Senior & Home IT Support">
                          Community, Senior & Home IT Support
                        </option>
                        <option value="Other Enquiry">Other Enquiry</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="contact-form-group">
                      <label htmlFor="message">
                        What Would You Like Improved?
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        className="contact-input contact-textarea"
                        rows="6"
                        required
                        placeholder="Tell us what you want to implement, improve, secure or govern: Microsoft 365 setup, SharePoint, Teams, automation, Azure, licensing, security, compliance, or managed IT"
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <button
                      type="submit"
                      className="contact-submit-btn"
                      disabled={isSending}
                    >
                      {isSending ? "Sending..." : "Request Health Check"}
                    </button>
                  </div>

                  <div className="col-12">
                    <p className="contact-form-note">
                      No obligation • Plain-English next steps • Microsoft cloud
                      transformation focused
                    </p>
                  </div>

                  {status && (
                    <div className="col-12">
                      <div className={`contact-form-status ${statusType}`}>
                        {status}
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
